import React, { useContext, useEffect } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUserPaper, CompiledDailyEngagedUsersRow } from '../styles';
import { startLoading, stopLoading } from '../../../api/CommonApi';
import { getMonthTwoDigits } from '../../../utils/date';
import CompiledOverspentInformations from './CompiledOverspentInformations';
import CompiledDailyEngagedUserTitle from './CompiledDailyEngagedUserTitle';
import CompiledPlanInformations from './CompiledPlanInformations';
import CompiledDailyEngagedUserProgressContent from './CompiledDailyEngagedUserProgressContent';
import CompiledDailyEngagedUserOverspentContent from './CompiledDailyEngagedUserOverspentContent';
import CompiledDailyEngagedUserTotalContent from './CompiledDailyEngagedUserTotalContent';
import CompiledDailyEngagedUserOverspentWarning from './CompiledDailyEngagedUserOverspentWarning';
import FeatureToggleService from '../../../services/FeatureToggleService';
import { DAILY_ENGAGED_USERS_PLAN_INFORMATIONS } from '../../../shared/FeatureToggleKeys';
import { useCommon } from '../../../contexts/CommonContext';

const CompiledDailyEngagedUserContainerComponent: React.FC = () => {
  const {
    content,
    dateToSearch,
    tenant,
    billingDailyEngagedUserApi,
    compiledDailyEngagedUserDataState,
    setMonthlyActiveMessageUsageState,
  } = useContext(DailyEngagedUsersContext);
  const { setHeaderContent } = useCommon();

  useEffect(() => {
    const getData = async () => {
      startLoading();
      setHeaderContent({
        redirect: '/',
        text: content.formatString(content.header, tenant.info.name),
      });

      const monthString = `${dateToSearch.getFullYear()}-${getMonthTwoDigits(dateToSearch)}`;
      const monthDate = content.compiledDailyEngagedUserInformation.month[dateToSearch.getMonth()];
      const compiledDailyUserConsumption = await billingDailyEngagedUserApi.getCompiDailyEngagedUserserConsumption(
        tenant.info.id,
        monthString,
      );

      const containsOverspent =
        compiledDailyUserConsumption != null &&
        !!compiledDailyUserConsumption.exceededPlan &&
        compiledDailyUserConsumption.exceededPlan > 0;

      const containsDataOnSelectedMonth =
        compiledDailyUserConsumption != null &&
        !!compiledDailyUserConsumption.metric.quantity &&
        compiledDailyUserConsumption.metric.quantity > 0;

      const containsPlanData =
        compiledDailyUserConsumption != null &&
        !!compiledDailyUserConsumption.metric &&
        !!compiledDailyUserConsumption.metric.quantity;

      const showDailyEngagedUserPlanInformations = await FeatureToggleService.isFeatureToggleEnabled(
        DAILY_ENGAGED_USERS_PLAN_INFORMATIONS,
      );

      setMonthlyActiveMessageUsageState({
        compiledDailyEngagedUserConsumption: compiledDailyUserConsumption,
        compiledContainsDataOnSelectedMonth: containsDataOnSelectedMonth,
        showPlanInformations: showDailyEngagedUserPlanInformations && containsPlanData,
        compiledMonthDate: monthDate,
        compiledContainsOverspent: containsOverspent,
      });
      stopLoading();
    };

    getData();
  }, [dateToSearch]);

  return (
    <CompiledDailyEngagedUserPaper>
      <div>
        <CompiledDailyEngagedUserTitle></CompiledDailyEngagedUserTitle>
        <CompiledPlanInformations></CompiledPlanInformations>
        <CompiledDailyEngagedUsersRow>
          <CompiledDailyEngagedUserProgressContent></CompiledDailyEngagedUserProgressContent>
          {compiledDailyEngagedUserDataState.compiledContainsOverspent && (
            <CompiledDailyEngagedUserOverspentContent></CompiledDailyEngagedUserOverspentContent>
          )}
          <CompiledDailyEngagedUserTotalContent></CompiledDailyEngagedUserTotalContent>
        </CompiledDailyEngagedUsersRow>
        <CompiledDailyEngagedUserOverspentWarning></CompiledDailyEngagedUserOverspentWarning>
        {compiledDailyEngagedUserDataState.showPlanInformations && (
          <CompiledOverspentInformations></CompiledOverspentInformations>
        )}
      </div>
    </CompiledDailyEngagedUserPaper>
  );
};

export default CompiledDailyEngagedUserContainerComponent;
